/* eslint-disable no-unused-vars */
export enum PROJECT_STATUS_ENUM {
  NEW = "project_new",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CLOSED = "closed",
  PENDING = "pending",
}

export const ProjectStatusConstants = {
  [PROJECT_STATUS_ENUM.NEW]: "新規",
  [PROJECT_STATUS_ENUM.IN_PROGRESS]: "進行中",
  [PROJECT_STATUS_ENUM.COMPLETED]: "完了",
  [PROJECT_STATUS_ENUM.CLOSED]: "クローズ",
  [PROJECT_STATUS_ENUM.PENDING]: "保留中",
};

export const ProjectStatusOptions = [
  {
    value: PROJECT_STATUS_ENUM.NEW,
    label: ProjectStatusConstants[PROJECT_STATUS_ENUM.NEW],
  },
  {
    value: PROJECT_STATUS_ENUM.IN_PROGRESS,
    label: ProjectStatusConstants[PROJECT_STATUS_ENUM.IN_PROGRESS],
  },
  {
    value: PROJECT_STATUS_ENUM.COMPLETED,
    label: ProjectStatusConstants[PROJECT_STATUS_ENUM.COMPLETED],
  },
  {
    value: PROJECT_STATUS_ENUM.CLOSED,
    label: ProjectStatusConstants[PROJECT_STATUS_ENUM.CLOSED],
  },
  {
    value: PROJECT_STATUS_ENUM.PENDING,
    label: ProjectStatusConstants[PROJECT_STATUS_ENUM.PENDING],
  },
];

export const projectTabTitleMap: Record<string, string> = {
  "project-overview": "プロジェクト概要",
  setting: "設定",
  quotation: "見積",
  progress: "進捗",
  "gantt-chart": "ガントチャート",
  "budget-vs-actual": "予実管理",
  "meeting-list": "会議一覧",
  "task-list": "カレンダー",
};

export const taskStatusMap = (status: string, task?: any) => {
  // Status "completed" from API => always show Completed, even if overdue
  if (task?.status === "completed") {
    return { text: "完了", class: "status-completed" };
  }
  if (task?.delayed_tasks && task?.$level === 1 && task?.itemType !== "task")
    return { text: `遅延${task?.delayed_tasks}件`, class: "status-delay" };
  if (task?.days_overdue && task?.$level === 1 && task?.itemType !== "task")
    return { text: `${task?.days_overdue}日遅延`, class: "status-delay" };
  // Parent task (itemType === "task" with children): show delayed children count or days overdue
  if (task?.itemType === "task" && task?.has_delayed_children) {
    const delayedCount = task?.delayed_children_count ?? 0;
    return { text: `遅延${delayedCount}件`, class: "status-delay" };
  }
  if (task?.days_overdue && task?.$level > 1)
    return { text: `${task?.days_overdue}日遅延`, class: "status-delay" };
  const statuses: Record<string, { text: string; class: string }> = {
    new: { text: "新規", class: "status-in-progress" },
    project_new: { text: "新規", class: "status-in-progress" },
    project_phase_new: { text: "未着手", class: "status-in-progress" },
    task_new: { text: "未着手", class: "status-in-progress" },
    in_progress: { text: "着手", class: "status-in-progress" },
    feedback: {
      text: "フィードバックあり",
      class: "status-in-progress",
    },
    canceled: { text: "中止", class: "status-in-progress" },
    reject: { text: "差し戻し", class: "status-in-progress" },
    closed: { text: "クローズ", class: "status-in-progress" },
    pending: { text: "保留", class: "status-in-progress" },
    delayed: {
      text: `遅延`,
      class: "status-delay",
    },
    completed: { text: "完了", class: "status-completed" },
  };

  return (
    statuses[status] ?? {
      text: status,
      class: "status-in-progress",
    }
  );
};
